import { canCreateOrUpdate } from './validators/functions/can-create-or-update.function';

export * from './dtos/vehicle-category-feature-item.dto';

export * from './enums/vehicle-category-feature-item-type.enum';

export * from './types/vehicle-category-feature-items-filters';

export * from './validators/schemas/vehicle-category-feature-item.schema';

export const vehicleCategoryFeatureItemValidators = { canCreateOrUpdate };
